<template>
  <v-app>
    <v-app-bar
      :clipped-left="primaryDrawer.clipped"
      app
      dark
      :color="$classStyle.mainColor"
      flat
    >
      <v-toolbar-title>寵物健檢雲平台</v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            large
            dark
            v-on="on"
            elevation="0"
            class="title px-0"
            :color="$classStyle.mainColor"
          >
            {{ $my.getName() }}
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>個人設定</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-title>登出</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <v-app-bar
        elevation="0"
        fixed
        :style="subHeaderStyle"
        :dense="$vuetify.breakpoint.smAndDown"
      >
        <v-app-bar-nav-icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-app-bar-nav-icon>

        <v-toolbar-title>
          <v-breadcrumbs :items="breadcrumbs" large class="pl-0" divider=">">
            <template v-slot:item="{ item }">
              <a
                class="title"
                href.stop
                @click="!item.disabled ? goTo(item.to) : ''"
                :style="{
                  color: 'grey',
                  cursor: item.disabled ? 'default' : 'pointer'
                }"
                >{{ item.text }}</a
              >
            </template>
          </v-breadcrumbs>
        </v-toolbar-title>
      </v-app-bar>
      <v-container
        fluid
        :style="{
          'margin-top': $vuetify.breakpoint.smAndDown ? '48px' : ' 64px'
        }"
      >
        <slot></slot>
      </v-container>
    </v-content>

    <v-footer inset app>
      <span class="px-4">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>
<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  height: 100%;
}
</style>
<script>
export default {
  props: ["items"],
  data: () => ({
    primaryDrawer: {
      model: null,
      clipped: true,
      mini: false
    },
    name: JSON.parse(localStorage.getItem("authAccount")).name,
    breadcrumbs: []
  }),
  computed: {
    subHeaderStyle() {
      let left = "0px";
      return {
        "z-index": 3,
        left: left,
        right: "0px",
        top: this.$vuetify.breakpoint.smAndDown ? "56px" : "64px"
      };
    }
  },
  watch: {
    $route: {
      handler: function(to) {
        let result = [];
        switch (to.name) {
          case "userProfile":
            result.push({
              text: "個人設定",
              disabled: true,
              to: "userProfile"
            });
            break;
        }
        this.breadcrumbs = result;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("authAccount");
      this.$router.push("/");
    }
  },
  created() {}
};
</script>
